import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TinvPurchasePharmacyBillSettlementService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private patientSearch = webapi + 'tinv_pharmacy_settlement/getPatientSearchInPharmacy/?';
    private getPharmacyCreditList = webapi + 'tinv_pharmacy_settlement/getPharmacyCreditListByUnitId/?';
    private AddRecord = webapi + 'tinv_pharmacy_settlement/create';
    private ListRecordByUnitId = webapi + 'tinv_pharmacy_settlement/listByUnitId/?';
    private getReturnListByPsIdUrl = webapi + 'tinv_pharmacy_settlement/getReturnItemListByPsId/?';
    private patientSearchForEdit = webapi + 'tinv_pharmacy_settlement/getPatientSearchInPharmacyEdit/?';
    private getPharmacyBillListEdit = webapi + 'tinv_pharmacy_settlement/getPharmacyListForEdit/?';
    private updatePharmacySalesUrl = webapi + 'tinv_pharmacy_settlement/updatePharmacySalesData';
    private getPharmacyReturnItemById = webapi + 'tinv_item_sales_return_item/getPharmacyReturnItemsByAdmisionId/?';

    constructor(private http: Http) {
    }

    onAddSettlePaymentData(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
    }

    getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any, listTypePharmacy: any): Promise<any> {
        return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId + '&listTypePharmacy=' + listTypePharmacy)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchPatientInPharmacy(qString: any, unitId: any, usePharmacy: any): Promise<any> {
        return this.http.get(this.patientSearch + 'qString=' + qString + '&unitId=' + unitId + '&usePharmacy=' + usePharmacy)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacyCreditListByUnitId(visitId: any, unitId: any, type: any): Promise<any> {
        return this.http.get(this.getPharmacyCreditList + '&visitId=' + visitId + '&unitId=' + unitId + '&type=' + type)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getReturnItemListByPsId(isrPsId: any): Promise<any> {
        return this.http.get(this.getReturnListByPsIdUrl + '&isrPsId=' + isrPsId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    searchPatientInPharmacyEdit(qString: any, unitId: any, pharmacyType: any): Promise<any> {
        return this.http.get(this.patientSearchForEdit + 'qString=' + qString + '&unitId=' + unitId + '&pharmacyType=' + pharmacyType)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPharmacyListForEdit(Id: any, unitId: any, pharmacyType: any): Promise<any> {
        return this.http.get(this.getPharmacyBillListEdit + '&Id=' + Id + '&unitId=' + unitId + '&pharmacyType=' + pharmacyType)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    onUpdatePharmacySalesData(model: any) {
        // console.log(JSON.stringify(model));
        return this.http.post(this.updatePharmacySalesUrl, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
    }

    //Use service by Jay for billing
    getPharmacyReturnItemByAddmisionId(admisionId: any): Promise<any> {
        return this.http.get(this.getPharmacyReturnItemById + 'admisionId=' + admisionId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/inventory/tinv-purchase-pharmacy-bill-settlement/tinv-purchase-pharmacy-bill-settlement.service.ts